import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.12",
  "description": "Turborepo 1.12는 커뮤니티에서 요청한 인기 기능 및 피드백 개선 사항을 추가합니다.",
  "date": "2024/01/30",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.12는 커뮤니티에서 요청한 인기 기능 및 피드백 개선 사항을 추가합니다:"
  }, {
    "heading": "",
    "content": "작업 로그의 색상: 기본적으로 원본 셸 로그의 색상 사용"
  }, {
    "heading": "",
    "content": "오류 개편: 잘못된 구성에 대한 개선된 오류 메시지"
  }, {
    "heading": "",
    "content": "개선된 inputs 인체공학: 입력 사용자 지정과 함께 Turborepo의 기본값 사용"
  }, {
    "heading": "",
    "content": "텔레메트리: Turborepo 사용자에게 가장 중요한 것에 집중할 수 있도록 도와주세요"
  }, {
    "heading": "",
    "content": "또한 이번 릴리스에서는 --go-fallback 플래그를 제거하고 turbo 바이너리를 1.11에 비해 58% 축소하여 Rust로의 마이그레이션 정리를 완료했습니다."
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 오늘 업데이트하거나 npx create-turbo@latest로 시작하세요."
  }, {
    "heading": "작업-로그의-색상",
    "content": "색상은 사용자 인터페이스에서 중요한 정보를 빠르게 표시하는 좋은 방법입니다. 개발자 도구가 성공을 녹색으로, 경고를 노란색으로, 오류를 빨간색으로 강조하는 것이 일반적입니다."
  }, {
    "heading": "작업-로그의-색상",
    "content": "이번 릴리스에서는 기본적으로 로컬 환경에서 기본 작업의 색상을 표시합니다. 이는 커뮤니티에서 인기 있는 요청이었으며 오늘 macOS 및 Linux에 대한 지원을 제공하게 되어 기쁩니다. 향후 릴리스에서 Windows 지원을 추가할 예정입니다."
  }, {
    "heading": "오류-개편",
    "content": "개발자 경험의 중요한 부분은 문제가 발생했을 때 행복한 경로로 돌아가는 방법이 명확하도록 하는 것입니다. 이번 릴리스에서는 Turborepo 잘못된 구성에서 발생하는 오류 메시지를 개선했습니다."
  }, {
    "heading": "오류-개편",
    "content": "이 향상된 UI에서 우리는:"
  }, {
    "heading": "오류-개편",
    "content": "오류가 있는 코드 표시"
  }, {
    "heading": "오류-개편",
    "content": "각 오류 유형에 대한 터미널의 도움말 텍스트 개선"
  }, {
    "heading": "오류-개편",
    "content": "유용한 컨텍스트를 제공할 수 있을 때 문서 링크 제공"
  }, {
    "heading": "개선된-inputs-인체공학",
    "content": "Turborepo는 기본적으로 작업에 대한 입력을 지능적으로 이해합니다. 그러나 작업 입력에서 특정 파일이나 디렉토리를 포함하거나 제외하려는 상황도 있습니다."
  }, {
    "heading": "개선된-inputs-인체공학",
    "content": "중요한 점은 작업에서 inputs 키를 사용하면 gitignored 파일을 입력에서 생략하는 것과 같이 작업의 모든 기본 입력에서 제외된다는 것입니다. 오늘까지는 이러한 기본값을 직접 glob 패턴을 생성하여 수동으로 다시 가져와야 했습니다."
  }, {
    "heading": "개선된-inputs-인체공학",
    "content": "오늘 우리는 inputs 배열에서 사용할 때 $TURBO_DEFAULT$를 특수 값으로 추가합니다."
  }, {
    "heading": "개선된-inputs-인체공학",
    "content": "이 마이크로 구문을 사용하면 익숙한 Turborepo 기본값을 사용하면서 기본 입력 동작을 미세 조정하기 위해 자신의 커스텀 glob을 추가할 수 있습니다."
  }, {
    "heading": "개선된-inputs-인체공학",
    "content": "자세한 내용은 inputs 문서를 확인하세요."
  }, {
    "heading": "텔레메트리",
    "content": "Turborepo는 거의 2년 전에 출시되었으며, 지난 2년 동안 turbo는 상당히 발전했습니다. 커뮤니티가 성장함에 따라 Turborepo 사용자에게 가장 중요한 것에 집중하는 데 있어 여러분의 피드백의 가치는 측정할 수 없습니다."
  }, {
    "heading": "텔레메트리",
    "content": "지금까지 피드백 수집 프로세스는 수동적이고 느리며 오류가 발생하기 쉬웠습니다. GitHub Issues를 제출하고, GitHub Discussions에서 대화하고, Discord에서 커뮤니티와 채팅하는 사용자를 항상 높이 평가하지만, 이 피드백은 Turboverse의 작은 일부의 정서만 포착합니다."
  }, {
    "heading": "텔레메트리",
    "content": "오늘 우리는 커뮤니티가 Turborepo를 사용하는 방식에 대해 자세히 알아보기 위해 완전히 익명의 자동화된 피드백 접근 방식을 도입합니다. turbo를 계속 반복함에 따라 이 정보는 성능을 보장하고, 안정성을 확인하고, 새로운 기능을 설계하고, 프로젝트의 방향을 주도하는 데 도움이 될 것입니다."
  }, {
    "heading": "텔레메트리",
    "content": "우리는 미래의 빌드 시스템을 만들고 있으며 이 정보는 그 노력을 안내하는 데 매우 가치가 있을 것입니다. 자세한 내용은 turborepo.com/docs/telemetry를 방문하세요."
  }, {
    "heading": "텔레메트리",
    "content": "텔레메트리를 선택 해제하려면 다음을 실행하세요:"
  }, {
    "heading": "텔레메트리",
    "content": "환경 변수를 설정하여 선택 해제할 수도 있습니다:"
  }, {
    "heading": "텔레메트리",
    "content": "TURBO_TELEMETRY_DISABLED=1"
  }, {
    "heading": "텔레메트리",
    "content": "DO_NOT_TRACK=1 (Console Do Not Track (DNT) 사양에 따름)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[기능]: pty 사용 활성화 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[기능]: inputs에서 $TURBO_DEFAULT$ 지원 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[기능]: Yarn 4 패치 지원 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[기능]: 텔레메트리 활성화 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 빈 환경 변수를 설정 해제된 것으로 처리 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 부모 없이 종속 플래그가 제공되면 오류 발생 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 동시성 검사가 작업이 없는 패키지를 무시하도록 함 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 잘못된 디렉토리 필터에서 패닉 방지 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: globbing 중 권한 오류 무시 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 재시도 패닉 방지 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 캐리지 리턴 후 접두사 다시 쓰기 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 그래프 확장 검증 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 쓸 때 메타데이터 파일 자르기 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 디렉토리에 대한 심볼릭 링크 올바르게 생성 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 쿠키를 쓰기 전에 쿠키 디렉토리가 존재하는지 확인 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 예제 turbo.json 출력 키 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 다른 패키지의 하위 폴더인 package.json 파일 필터링 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 정규화 중 종속 항목 및 종속성 정렬 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 폴백 로그를 디버그로 교체 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 폴백에 gitignored 파일 포함 (PR)"
  }, {
    "heading": "기타-개선-사항",
    "content": "[개선]: 폴백에 기본 파일 포함 (PR)"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo 1.11 출시 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "24.0k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "주간 NPM 다운로드 1.9M+회"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel Remote Cache를 사용하여 238년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 노력이 결합된 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 선택하기 위해 지속적인 지원, 피드백, 협업에 감사드립니다."
  }],
  "headings": [{
    "id": "작업-로그의-색상",
    "content": "작업 로그의 색상"
  }, {
    "id": "오류-개편",
    "content": "오류 개편"
  }, {
    "id": "개선된-inputs-인체공학",
    "content": "개선된 inputs 인체공학"
  }, {
    "id": "텔레메트리",
    "content": "텔레메트리"
  }, {
    "id": "기타-개선-사항",
    "content": "기타 개선 사항"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {ThemeAwareImage} from '#components/theme-aware-image';
export const toc = [{
  depth: 2,
  url: "#작업-로그의-색상",
  title: _jsx(_Fragment, {
    children: "작업 로그의 색상"
  })
}, {
  depth: 2,
  url: "#오류-개편",
  title: _jsx(_Fragment, {
    children: "오류 개편"
  })
}, {
  depth: 2,
  url: "#개선된-inputs-인체공학",
  title: _jsxs(_Fragment, {
    children: ["개선된 ", _jsx("code", {
      children: "inputs"
    }), " 인체공학"]
  })
}, {
  depth: 2,
  url: "#텔레메트리",
  title: _jsx(_Fragment, {
    children: "텔레메트리"
  })
}, {
  depth: 2,
  url: "#기타-개선-사항",
  title: _jsx(_Fragment, {
    children: "기타 개선 사항"
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.12"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, January 30th, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['mehulkar', 'tomknickman', 'gregsoltis']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.12는 커뮤니티에서 요청한 인기 기능 및 피드백 개선 사항을 추가합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#colors-in-task-logs",
          children: _jsx(_components.strong, {
            children: "작업 로그의 색상"
          })
        }), ": 기본적으로 원본 셸 로그의 색상 사용"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#errors-overhaul",
          children: _jsx(_components.strong, {
            children: "오류 개편"
          })
        }), ": 잘못된 구성에 대한 개선된 오류 메시지"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-inputs-ergonomics",
          children: _jsxs(_components.strong, {
            children: ["개선된 ", _jsx(_components.code, {
              children: "inputs"
            }), " 인체공학"]
          })
        }), ": 입력 사용자 지정과 함께 Turborepo의 기본값 사용"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#telemetry",
          children: _jsx(_components.strong, {
            children: "텔레메트리"
          })
        }), ": Turborepo 사용자에게 가장 중요한 것에 집중할 수 있도록 도와주세요"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["또한 이번 릴리스에서는 ", _jsx(_components.code, {
        children: "--go-fallback"
      }), " 플래그를 제거하고 ", _jsx(_components.code, {
        children: "turbo"
      }), " 바이너리를 1.11에 비해 58% 축소하여 Rust로의 마이그레이션 정리를 완료했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 오늘 업데이트하거나 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "로 시작하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "작업-로그의-색상",
      children: "작업 로그의 색상"
    }), "\n", _jsx(_components.p, {
      children: "색상은 사용자 인터페이스에서 중요한 정보를 빠르게 표시하는 좋은 방법입니다. 개발자 도구가 성공을 녹색으로, 경고를 노란색으로, 오류를 빨간색으로 강조하는 것이 일반적입니다."
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A screenshot of a terminal running a `turbo` task with colors from the underlying shell logs.',
        src: '/images/blog/turbo-1-12-0/log-colors-light.png',
        props: {
          width: 625,
          height: 1000,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: 'A screenshot of a terminal running a `turbo` task with colors from the underlying shell logs.',
        src: '/images/blog/turbo-1-12-0/log-colors-dark.png',
        props: {
          width: 625,
          height: 1000,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsx(_components.p, {
      children: "이번 릴리스에서는 기본적으로 로컬 환경에서 기본 작업의 색상을 표시합니다. 이는 커뮤니티에서 인기 있는 요청이었으며 오늘 macOS 및 Linux에 대한 지원을 제공하게 되어 기쁩니다. 향후 릴리스에서 Windows 지원을 추가할 예정입니다."
    }), "\n", _jsx(_components.h2, {
      id: "오류-개편",
      children: "오류 개편"
    }), "\n", _jsx(_components.p, {
      children: "개발자 경험의 중요한 부분은 문제가 발생했을 때 행복한 경로로 돌아가는 방법이 명확하도록 하는 것입니다. 이번 릴리스에서는 Turborepo 잘못된 구성에서 발생하는 오류 메시지를 개선했습니다."
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A screenshot of a terminal attempting to run a `turbo` task but receiving an informative error that an unknown key `output`, was found in the `turbo.json` file.',
        src: '/images/blog/turbo-1-12-0/light-errors-overhaul.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: 'A screenshot of a terminal attempting to run a `turbo` task but receiving an informative error that an unknown key `output`, was found in the `turbo.json` file.',
        src: '/images/blog/turbo-1-12-0/errors-overhaul-dark.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsx(_components.p, {
      children: "이 향상된 UI에서 우리는:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "오류가 있는 코드 표시"
      }), "\n", _jsx(_components.li, {
        children: "각 오류 유형에 대한 터미널의 도움말 텍스트 개선"
      }), "\n", _jsx(_components.li, {
        children: "유용한 컨텍스트를 제공할 수 있을 때 문서 링크 제공"
      }), "\n"]
    }), "\n", _jsxs(_components.h2, {
      id: "개선된-inputs-인체공학",
      children: ["개선된 ", _jsx(_components.code, {
        children: "inputs"
      }), " 인체공학"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 기본적으로 작업에 대한 입력을 지능적으로 이해합니다. 그러나 작업 입력에서 특정 파일이나 디렉토리를 포함하거나 제외하려는 상황도 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["중요한 점은 작업에서 ", _jsx(_components.code, {
        children: "inputs"
      }), " 키를 사용하면 gitignored 파일을 입력에서 생략하는 것과 같이 작업의 모든 기본 입력에서 제외된다는 것입니다. 오늘까지는 이러한 기본값을 직접 glob 패턴을 생성하여 수동으로 다시 가져와야 했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["오늘 우리는 ", _jsx(_components.code, {
        children: "inputs"
      }), " 배열에서 사용할 때 ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), "를 특수 값으로 추가합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!README.md\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!**.test.**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이 마이크로 구문을 사용하면 익숙한 Turborepo 기본값을 사용하면서 기본 입력 동작을 미세 조정하기 위해 자신의 커스텀 glob을 추가할 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#inputs",
        children: [_jsx(_components.code, {
          children: "inputs"
        }), " 문서"]
      }), "를 확인하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "텔레메트리",
      children: "텔레메트리"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 거의 2년 전에 출시되었으며, 지난 2년 동안 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 상당히 발전했습니다. 커뮤니티가 성장함에 따라 Turborepo 사용자에게 가장 중요한 것에 집중하는 데 있어 여러분의 피드백의 가치는 측정할 수 없습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["지금까지 피드백 수집 프로세스는 수동적이고 느리며 오류가 발생하기 쉬웠습니다. ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/issues",
        children: "GitHub Issues"
      }), "를 제출하고, ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/discussions",
        children: "GitHub Discussions"
      }), "에서 대화하고, ", _jsx(_components.a, {
        href: "https://turborepo.com/discord",
        children: "Discord"
      }), "에서 커뮤니티와 채팅하는 사용자를 항상 높이 평가하지만, 이 피드백은 Turboverse의 작은 일부의 정서만 포착합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["오늘 우리는 커뮤니티가 Turborepo를 사용하는 방식에 대해 자세히 알아보기 위해 ", _jsx(_components.strong, {
        children: "완전히 익명"
      }), "의 자동화된 피드백 접근 방식을 도입합니다. ", _jsx(_components.code, {
        children: "turbo"
      }), "를 계속 반복함에 따라 이 정보는 성능을 보장하고, 안정성을 확인하고, 새로운 기능을 설계하고, 프로젝트의 방향을 주도하는 데 도움이 될 것입니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["우리는 미래의 빌드 시스템을 만들고 있으며 이 정보는 그 노력을 안내하는 데 매우 가치가 있을 것입니다. 자세한 내용은 ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/telemetry",
        children: "turborepo.com/docs/telemetry"
      }), "를 방문하세요."]
    }), "\n", _jsx(_components.p, {
      children: "텔레메트리를 선택 해제하려면 다음을 실행하세요:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " disable"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "환경 변수를 설정하여 선택 해제할 수도 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "TURBO_TELEMETRY_DISABLED=1"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "DO_NOT_TRACK=1"
        }), " (", _jsx(_components.a, {
          href: "https://consoledonottrack.com/",
          children: "Console Do Not Track (DNT)"
        }), " 사양에 따름)"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "기타-개선-사항",
      children: "기타 개선 사항"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[기능]"
        }), ": pty 사용 활성화 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7128",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[기능]"
        }), ": inputs에서 ", _jsx(_components.code, {
          children: "$TURBO_DEFAULT$"
        }), " 지원 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7113",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[기능]"
        }), ": Yarn 4 패치 지원 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6974",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[기능]"
        }), ": 텔레메트리 활성화 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7122",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 빈 환경 변수를 설정 해제된 것으로 처리 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6929",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 부모 없이 종속 플래그가 제공되면 오류 발생 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6780",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 동시성 검사가 작업이 없는 패키지를 무시하도록 함 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6790",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 잘못된 디렉토리 필터에서 패닉 방지 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6955",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": globbing 중 권한 오류 무시 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6957",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 재시도 패닉 방지 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6926",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 캐리지 리턴 후 접두사 다시 쓰기 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6989",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 그래프 확장 검증 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6995",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 쓸 때 메타데이터 파일 자르기 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7016",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 디렉토리에 대한 심볼릭 링크 올바르게 생성 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6983",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 쿠키를 쓰기 전에 쿠키 디렉토리가 존재하는지 확인 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7015",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 예제 turbo.json 출력 키 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7071",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 다른 패키지의 하위 폴더인 package.json 파일 필터링 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7025",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 정규화 중 종속 항목 및 종속성 정렬 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7018",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 폴백 로그를 디버그로 교체 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7102",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 폴백에 gitignored 파일 포함 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7105",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[개선]"
        }), ": 폴백에 기본 파일 포함 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7106",
          children: "(PR)"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-1-11-0",
        children: "Turborepo 1.11"
      }), " 출시 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "24.0k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "주간 NPM 다운로드 1.9M+회"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        }), "를 사용하여 238년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 노력이 결합된 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 빌드 도구로 선택하기 위해 지속적인 지원, 피드백, 협업에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
